"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _underscore = require("underscore");

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _generalStore = require("general-store");

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var _phraseDetection = _interopRequireDefault(require("draft-smart-detections/utils/phraseDetection"));

var _entityUtils = require("draft-smart-detections/utils/entityUtils");

var _phrases = require("draft-smart-detections/rules/lib/phrases");

var _constants = require("draft-plugins/lib/constants");

var _acceleratorLimits = _interopRequireDefault(require("crm_internal/config/acceleratorLimits"));

var createMeetingsProTipEntityOptions = function createMeetingsProTipEntityOptions(phrase, offset, blockKey) {
  return [_constants.MEETINGS_PRO_TIP_ENTITY_KEY, 'MUTABLE', {
    phrase: phrase,
    offset: offset,
    blockKey: blockKey
  }];
};

var isLinkInEditorState = function isLinkInEditorState(editorState) {
  var editorStateText = editorState.getCurrentContent().getPlainText();
  return editorStateText.indexOf('meetings/') > -1;
};

var doesMeetingExist = function doesMeetingExist(contentBlock, contentState) {
  var linkEntities = (0, _immutable.List)();
  contentBlock.findEntityRanges(function (char) {
    var entityKey = char.getEntity();
    return char.getEntity() !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, function (start) {
    linkEntities = linkEntities.push(start);
  });
  return linkEntities.reduce(function (isMeeting, linkEntityIndex) {
    if (isMeeting) {
      return true;
    }

    var linkEntityKey = contentBlock.getEntityAt(linkEntityIndex);

    var _contentState$getEnti = contentState.getEntity(linkEntityKey).getData(),
        url = _contentState$getEnti.url;

    return url && url.includes('meetings/');
  }, false);
};

var dependencies = {
  hideMeetingsProTip: {
    stores: [_UserSettingsStore.default],
    deref: function deref() {
      return _UserSettingsStore.default.get(_UserSettingsKeys.default.HIDE_MEETINGS_PRO_TIP);
    }
  }
};

var _default = function _default(WrappingComponent) {
  if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
    var MeetingsAutoDetection = (0, _createReactClass.default)({
      propTypes: {
        hideMeetingsProTip: _propTypes.default.bool,
        editorState: _propTypes.default.instanceOf(_draftJs.EditorState).isRequired,
        onChange: _propTypes.default.func.isRequired
      },
      getDefaultProps: function getDefaultProps() {
        return {
          hideMeetingsProTip: false
        };
      },
      getInitialState: function getInitialState() {
        return {
          hasSeenPopup: false
        };
      },
      componentWillMount: function componentWillMount() {
        this.debounceCheckForMeeting = (0, _underscore.debounce)(this.checkForMeeting, 1000);
      },
      checkForMeeting: function checkForMeeting() {
        var _editorState$getCurre;

        var hideMeetingsProTip = this.props.hideMeetingsProTip;
        var hasMeetings = (0, _acceleratorLimits.default)().meetings.hasMeetings;

        if (hideMeetingsProTip || !hasMeetings || this.state.hasSeenPopup) {
          return;
        }

        var _this$props = this.props,
            onChange = _this$props.onChange,
            editorState = _this$props.editorState;

        if (isLinkInEditorState(editorState)) {
          return;
        }

        var meetingPhrase = (0, _phraseDetection.default)(editorState, (0, _phrases.getMeetingPhrases)(), doesMeetingExist);

        if (meetingPhrase === null) {
          return;
        }

        var _meetingPhrase$toObje = meetingPhrase.toObject(),
            phrase = _meetingPhrase$toObje.phrase,
            offset = _meetingPhrase$toObje.offset,
            blockKey = _meetingPhrase$toObje.blockKey;

        var contentStateWithEntity = (_editorState$getCurre = editorState.getCurrentContent()).createEntity.apply(_editorState$getCurre, (0, _toConsumableArray2.default)(createMeetingsProTipEntityOptions(phrase, offset, blockKey)));

        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var editorStateWithMeeting = (0, _entityUtils.replaceTextWithEntity)(_draftJs.EditorState.set(editorState, {
          currentContent: contentStateWithEntity
        }), meetingPhrase, entityKey);
        onChange(_draftJs.EditorState.forceSelection(editorStateWithMeeting, editorState.getSelection()));
        this.setState({
          hasSeenPopup: true
        });
      },
      handleOnChange: function handleOnChange(nextEditorState) {
        var onChange = this.props.onChange;
        this.debounceCheckForMeeting();
        onChange(nextEditorState);
      },
      render: function render() {
        return _react.default.createElement(WrappingComponent, (0, _extends2.default)({}, this.props, {
          onChange: this.handleOnChange
        }));
      }
    });
    return (0, _generalStore.connect)(dependencies)(MeetingsAutoDetection);
  }

  return WrappingComponent;
};

exports.default = _default;
module.exports = exports.default;